/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createParenthesisNode } from '../../factoriesAny.js';
export var ParenthesisNodeDependencies = {
  NodeDependencies,
  createParenthesisNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesParenthesisNode.generated.js
// module id = 152
// module chunks = 2